import React from 'react';
import PropTypes from 'prop-types';
import PinProtectedAction from './PinProtectedAction';

/**
 * Self-contained button component that provides PIN protection for a single action
 * @param {object} props - Component props
 * @returns {JSX.Element} - Button with PIN protection
 */
const PinProtectedButton = ({
  children,
  clubId,
  actionType,
  onAction,
  actionData = null,
  description = '', // Add description prop with default empty string
  disabled = false,
  onPinError = null,
  ...buttonProps
}) => {
  return (
    <PinProtectedAction clubId={clubId} onPinError={onPinError}>
      {({ requestPinValidation }) => {
        const handleClick = (e) => {
          e.preventDefault();
          if (disabled) return;

          requestPinValidation(actionType, onAction, actionData, description); // Pass description
        };

        // Clone the button element and add the click handler
        return React.cloneElement(children, {
          ...buttonProps,
          onClick: handleClick,
          disabled: disabled,
        });
      }}
    </PinProtectedAction>
  );
};

PinProtectedButton.propTypes = {
  children: PropTypes.element.isRequired,
  clubId: PropTypes.string.isRequired,
  actionType: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
  actionData: PropTypes.any,
  description: PropTypes.string, // Add description to PropTypes
  disabled: PropTypes.bool,
  onPinError: PropTypes.func,
};

export default PinProtectedButton;
